/*
 * Copyright Camunda Services GmbH and/or licensed to Camunda Services GmbH under
 * one or more contributor license agreements. See the NOTICE file distributed
 * with this work for additional information regarding copyright ownership.
 * Licensed under the Camunda License 1.0. You may not use this file
 * except in compliance with the Camunda License 1.0.
 */

import { Button, FormLabel } from '@carbon/react';
import styled from 'styled-components';
import { C3ClusterTag } from '@camunda/camunda-composite-components';

import { defineStagesModalStore } from 'App/Pages/Diagram/Deployment/defineStagesModal';

export default function DevelopmentClusterSelection({ clusters, developmentClusterId, closeModal }) {
  const developmentCluster = clusters?.find((cluster) => cluster.id === developmentClusterId);

  return (
    developmentCluster && (
      <>
        Your process application will be deployed to the defined development cluster to launch Play.
        <Container>
          <DevClusterInfo>
            <FormLabel>Development cluster</FormLabel>
            <ClusterContent>
              <C3ClusterTag stage="dev" />{' '}
              <ClusterName>{`${developmentCluster.name} ${developmentCluster?.version ? `(${developmentCluster.version})` : ''}`}</ClusterName>
            </ClusterContent>
          </DevClusterInfo>
          <Button
            size="md"
            kind="tertiary"
            onClick={() => {
              closeModal();
              defineStagesModalStore.open({ executeModalMode: 'play' });
            }}
          >
            Define stages
          </Button>
        </Container>
      </>
    )
  );
}

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: end;
  gap: 10px;
`;

const DevClusterInfo = styled.div``;

const ClusterContent = styled.div`
  height: 40px;
  align-content: center;
`;

const ClusterName = styled.span`
  vertical-align: middle;
`;
